export default {
  pages: {
    tour: {
      tabsLabel: "Detalles del paseo",
      gallery: {
        label: "Galería de fotos",
        position: "Foto {{n}} de {{total}}",
        expand: "Ampliar",
        dialog: "Fotos a pantalla completa",
      },
    },
    legalNav: "Otras políticas",
    cart: {
      summary: "Resumen de la reserva",
    },
    paymentReturn: {
      reservation: "Reserva",
    },
    notFound: {
      seoTitle: 'Página no encontrada',
    },
    category: {
      notFoundTitle: 'Categoría no encontrada',
      subtitles: {
        escunas:
          'Navega por las aguas cristalinas de Paraty a bordo de barcos tradicionales y de lujo. Paseos compartidos o privados, con paradas en playas paradisíacas.',
        privadas:
          'Exclusividad total para tu grupo. Elige el itinerario y el ritmo, y disfruta de las playas de Paraty sin multitudes, a bordo de cómodas lanchas.',
        compartilhadas:
          'Aventuras en grupo por las aguas de Paraty. Paseos en lancha compartida a precios accesibles y con experiencias inolvidables.',
        jeep:
          'Aventúrate por la Mata Atlántica, cascadas, alambiques y la Estrada Real de Paraty en emocionantes paseos en jeep 4x4.',
        bolivia:
          '¡Descubre el desierto de sal más grande del mundo! Expediciones inolvidables por el Altiplano Boliviano — Salar de Uyuni, lagunas de colores, géiseres, volcanes y paisajes surrealistas.',
      },
    },
    about: {
      title: 'Sobre Nosotros',
      whoTitle: 'Quiénes somos',
      whoText:
        'AQUAMARINA TOURS ofrece experiencias de paseo en Paraty, enfocadas en rutas por el mar, naturaleza, playas, islas y paisajes de la Costa Verde. Nuestra operación combina los paseos con atención al itinerario, comodidad y seguridad durante toda la experiencia.',
      whereTitle: 'Dónde operamos',
      whereText:
        'Operamos en Paraty y sus alrededores, incluyendo rutas por la bahía, playas, puntos de buceo, senderos y experiencias de paseo en embarcaciones y vehículos 4x4.',
      proposalTitle: 'Nuestra propuesta',
      proposalText1:
        'La propuesta de AQUAMARINA TOURS es ofrecer itinerarios que conecten el mar, los paisajes y la cultura local, con foco en experiencias auténticas y bien organizadas para visitantes, grupos y familias.',
      proposalText2:
        'Para obtener información específica sobre cada paseo, duración, punto de encuentro, condiciones y disponibilidad, consulta la página del paseo que te interesa o contáctanos directamente.',
    },
    contact: {
      title: 'Contacto',
      talkTitle: 'Habla con nosotros',
      whatsapp: 'WhatsApp',
      phone: 'Teléfono',
      email: 'Correo electrónico',
      location: 'Ubicación',
      locationValue: 'Paraty, RJ — Brasil',
      howTitle: 'Cómo reservar',
      howText:
        'Para reservar o confirmar disponibilidad, contáctanos por WhatsApp o teléfono, o usa el formulario disponible en la sección de contacto del sitio. Indica la fecha deseada, la cantidad de personas y el paseo que te interesa.',
      hoursText:
        'Horario de atención: todos los días, de 8:30 a 22:00. Fuera de este horario, responderemos tu mensaje en cuanto el equipo esté disponible.',
    },
    legal: {
      privacy: {
        heading: 'Política de Privacidad',
        body: [
          'AQUAMARINA TOURS recopila y utiliza datos únicamente para fines de atención, contacto, reserva y prestación del servicio solicitado.',
          'Los datos pueden incluir nombre, contacto, información de la reserva y mensajes enviados por formulario, WhatsApp u otros canales de comunicación.',
          'El sitio puede utilizar herramientas externas de análisis, alojamiento y contacto, según la tecnología efectivamente utilizada. Los datos no se compartirán con terceros, salvo con los proveedores necesarios para la operación del servicio.',
          'El usuario puede solicitar aclaraciones, corrección o eliminación de sus datos, de acuerdo con la legislación aplicable, por correo electrónico a paraty.sirenatours@gmail.com o por WhatsApp al +55 11 95245-1307.',
        ],
      },
      cookies: {
        heading: 'Política de Cookies',
        body: [
          'Actualmente, el sitio utiliza solo las tecnologías necesarias para cargar la aplicación, mantener la navegación y ofrecer los recursos solicitados por el usuario.',
          'Por el momento, AQUAMARINA TOURS no ha configurado Google Analytics, Google Tag Manager ni cookies publicitarias en el sitio.',
          'Si se instalan nuevas herramientas analíticas o publicitarias, esta política se actualizará y se solicitará el consentimiento cuando lo exija la legislación aplicable.',
          'El usuario también puede controlar o eliminar las cookies desde la configuración de su propio navegador.',
        ],
      },
      terms: {
        heading: 'Términos y Condiciones',
        seller: {
          title: 'Datos legales del vendedor',
          name: 'Nombre completo',
          document: 'Documento de identidad',
          brand: 'Nombre comercial',
          address: 'Dirección de atención',
          email: 'Correo electrónico',
          whatsapp: 'WhatsApp',
        },
        body: [
          'Estos Términos y Condiciones rigen la compra de paseos turísticos en el sitio aquamarinatours.art. La venta la realiza {{sellerName}}, documento de identidad n.º {{sellerDocument}}, bajo el nombre comercial AQUAMARINA TOURS, con atención en Paraty, RJ, Brasil.',
          'Al hacer una reserva o un pago en el sitio, el cliente declara haber leído y aceptado estos términos, la Política de Reservas, la Política de Cancelaciones y la Política de Privacidad.',
          'El sitio vende reservas de paseos en Paraty y alrededores (barcos, lanchas, paseos en jeep y otras experiencias). Los paseos los realizan embarcaciones, vehículos y guías de operadores locales; AQUAMARINA TOURS es responsable de la venta, la reserva y la atención al cliente antes y después del paseo.',
          'Los precios se muestran en reales brasileños (R$), por persona o por la embarcación o el grupo completo, según se indique en cada paseo. Los valores de niños y bebés, lo que incluye y lo que no incluye figuran en la página de cada paseo. El total, la seña y el saldo se muestran antes del pago.',
          'En los paseos con reserva en línea, el cliente paga ahora una seña (el porcentaje aparece en el resumen antes del pago) con Pix o tarjeta de crédito, y el saldo, si lo hay, el día del paseo. Los pagos en línea los procesan plataformas de pago seguras, como Mercado Pago; los datos de la tarjeta se ingresan en el formulario de la plataforma y AQUAMARINA TOURS no los guarda.',
          'Algunos paseos, como los privados, se reservan mediante cotización por WhatsApp: el sitio no cobra nada, y el precio y las condiciones se acuerdan por escrito antes del pago.',
          'La reserva queda confirmada cuando se aprueba el pago de la seña. Luego el cliente recibe por correo electrónico los datos de la reserva y las indicaciones del paseo. Una reserva con Pix no pagado dentro del plazo indicado en el pago se cancela automáticamente, sin costo.',
          'En casos excepcionales, como un lugar ocupado en el mismo instante por otro cliente, la reserva puede quedar en revisión. Si no se puede confirmar, se avisa al cliente y se le devuelve el total pagado.',
          'Cancelación por el cliente con 7 días o más de anticipación: reembolso del 100% de lo pagado. Entre 7 días y 48 horas antes: reembolso del 80%. Con menos de 48 horas o si no se presenta: sin reembolso. Los reembolsos se hacen por el mismo medio de pago utilizado. Más detalles en la Política de Cancelaciones.',
          'El operador puede modificar, posponer o cancelar el paseo por condiciones climáticas, de seguridad o por orden de las autoridades (como la Marina de Brasil). En esos casos, el cliente elige entre reprogramar sin costo o recibir el reembolso del 100% de lo pagado.',
          'El cliente debe informar datos correctos (nombre, correo, teléfono y documento), llegar al punto de encuentro a la hora indicada, presentar un documento de identidad cuando se le pida y seguir las indicaciones de la tripulación y de los guías. Los menores de edad deben ir acompañados por un adulto responsable.',
          'Los datos personales informados se usan solo para la reserva, el pago, la atención y el envío de la confirmación, según la Política de Privacidad y la ley brasileña de protección de datos (LGPD).',
          'Consultas, cambios y reclamos: correo {{email}} o WhatsApp {{phone}}.',
          'Estos términos se rigen por la legislación brasileña, en especial el Código de Defensa del Consumidor. Para resolver cualquier conflicto se elige el foro del domicilio del consumidor.',
          'AQUAMARINA TOURS puede actualizar estos términos; siempre vale la versión publicada en el momento de la compra.',
        ],
        updated: 'Última actualización: 27 de octubre de 2026.',
        acceptNote: 'Al pagar, aceptas los <terms>Términos y Condiciones</terms> y la <cancel>Política de Cancelaciones</cancel>.',
      },
      reservations: {
        heading: 'Política de Reservas',
        body: [
          'Las reservas pueden confirmarse contactando a AQUAMARINA TOURS por WhatsApp, teléfono o el canal indicado en el sitio.',
          'Antes de la confirmación final, deben verificarse la disponibilidad, la fecha, el itinerario, el punto de encuentro y las condiciones específicas del paseo.',
          'La reserva se confirma cuando el cliente paga una seña del 20% del valor total del paseo.',
          'El pago puede realizarse mediante PIX o tarjeta de crédito, incluidas Visa y Mastercard, según las indicaciones del equipo de atención.',
          'Una vez confirmada la seña, el equipo enviará la información de la reserva y del paseo por el canal de atención utilizado.',
        ],
      },
      cancellations: {
        heading: 'Política de Cancelaciones',
        body: [
          'Las cancelaciones deben comunicarse por el medio acordado con AQUAMARINA TOURS.',
          'Cancelación con 7 días o más de anticipación: reembolso del 100% del valor pagado.',
          'Cancelación entre 7 días y 48 horas antes del paseo: se retiene el 20% del valor pagado y se reembolsa el 80%.',
          'Cancelación con menos de 48 horas de anticipación o no presentación (no-show): no habrá reembolso.',
          'Si la empresa cancela el paseo por motivos de seguridad, condiciones climáticas u operativas, el cliente podrá reprogramarlo o recibir el reembolso del 100% del valor pagado.',
          'Esta política se rige por el Código de Defensa del Consumidor de Brasil y la legislación brasileña aplicable.',
        ],
      },
    },
  },
};
